
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 511.95 117.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ff576d","d":"M58.88 117.5H30.37a3.87 3.87 0 01-4.18-3.5L.24 3.85Q-.93 0 3.59 0h15.73q3.35 0 4 3.51l20.89 92.23h.67L65.74 3.51Q66.41 0 69.76 0h15.73q4.18 0 3.35 3.85L62.9 114q-.84 3.51-4 3.51M157.75 117.5H103q-3.51 0-3.51-3.51V3.51Q99.5 0 103 0h54.73q3.35 0 3.35 3.51V14.9q0 3.51-3.35 3.51h-35q-2 0-2 1.84v35.68c0 1.23.67 1.84 2 1.84h22q3.51 0 3.51 3.52v11q0 3.52-3.51 3.52h-22q-2 0-2 1.84v19.6q0 1.84 2 1.84h35q3.35 0 3.35 3.51V114q0 3.51-3.35 3.51M191.38 117.5h-14.22q-3.52 0-3.52-3.51V3.52q0-3.51 3.52-3.52H217q13 0 20.41 7.2t7.36 20.25v19.64q0 18.92-14.9 25.11v.67l17.91 40.62q1.51 4-2.84 4h-13.55a10.36 10.36 0 01-4.35-.67 5 5 0 01-2.18-2.84L208.12 76h-11.21q-2 0-2 1.84V114q0 3.51-3.52 3.51M196.74 58h16.4q5.35 0 7.86-2.26t2.51-7.28V28.29q0-5.18-2.51-7.53t-7.86-2.34h-16.4a1.63 1.63 0 00-1.84 1.84v35.9a1.63 1.63 0 001.84 1.84M280.7 3.52V114q0 3.51-3.52 3.51H263q-3.52 0-3.52-3.51V3.52Q259.45 0 263 0h14.22q3.52 0 3.52 3.52M313.9 117.5h-14.23q-3.51 0-3.51-3.51V3.51q0-3.51 3.51-3.51h53.39q3.35 0 3.34 3.51V14.9q0 3.51-3.34 3.51h-33.64q-2 0-2 1.84v35.26a1.77 1.77 0 002 2h22Q345 57.52 345 61v11.25q0 3.68-3.51 3.68h-22q-2 0-2 1.84V114q0 3.51-3.52 3.51M477.86 3.52V114q0 3.51-3.52 3.51h-14.22q-3.51 0-3.51-3.51V3.52q0-3.51 3.51-3.52h14.23q3.52 0 3.52 3.52M512 100.2v13.44q0 3.86-3.86 3.86h-13.58q-3.86 0-3.86-3.86V100.2q0-3.86 3.86-3.86h13.54q3.86 0 3.86 3.86M443.53 113.65L417.58 3.51A3.87 3.87 0 00413.4 0h-28.52q-3.17 0-4 3.51l-25.95 110.14q-.83 3.85 3.35 3.85H374q3.35 0 4-3.51l6.1-27h30.2l6.1 27q.67 3.51 4 3.51h15.73q4.52 0 3.35-3.85m-55.29-44.59l10.7-47.3h.67l10.7 47.3z"}})])
          )
        }
      }
    